import MPN from './MPN'

export default MPN